module.exports = __webpack_public_path__ + "img/culture.bf621201.png";